import React, { useState } from 'react';
import { currency } from '@utils';

import { FLink, Table } from '@components';

export const ContribuicoesCard = () => {
  const [contribuicoes] = useState([
    { id: 1, mes: 'DEZ', voce: 366.1, empresa: 366.1, total: 732.21 },
    { id: 2, mes: 'NOV', voce: 364.58, empresa: 364.58, total: 729.17 },
    { id: 3, mes: 'OUT', voce: 364.56, empresa: 364.56, total: 729.12 },
    { id: 4, mes: 'SET', voce: 364.26, empresa: 364.26, total: 728.52 },
  ]);
  return (
    <div className="card h-100">
      <div className="card-body">
        <h1 className="ts-20 fw-bold mb-2">Contribuições</h1>
        <p className="ts-14 text-muted mb-32">
          Acompanhe, nos últimos quatro meses, as contribuições suas e da
          patrocinadora, além do valor gerado pela rentabilidade do seu saldo.
        </p>
        <Table columns={['', 'Você', 'Empresa', 'Total']}>
          {contribuicoes.map((cont) => (
            <tr key={cont.id}>
              <td className="fw-bold">{cont.mes}</td>
              <td>{currency(cont.voce)}</td>
              <td>{currency(cont.empresa)}</td>
              <td className="fw-bold">{currency(cont.total)}</td>
            </tr>
          ))}
        </Table>
        <FLink className="mt-3" to="/" icon>
          Ver mais
        </FLink>
      </div>
      <div className="card-footer">
        <hr className="mb-3" />
        <FLink to="/" icon>
          Baixar relatório de contribuições
        </FLink>
        <hr className="my-3" />
        <FLink to="/" icon>
          Alterar percentual de contruição
        </FLink>
        <hr className="my-3" />
        <FLink to="/" icon>
          Solicitar novo aporte
        </FLink>
        <hr className="my-3" />
        <FLink to="/" icon>
          2ª via de boleto
        </FLink>
        <hr className="my-3" />
        <FLink to="/" icon>
          Suspender contribuição
        </FLink>
        <hr className="my-3" />
        <FLink to="/" icon>
          Retomar contribuição
        </FLink>
      </div>
    </div>
  );
};
